import React, { useState } from "react";
import "./HeroSection.css";
import { Helmet } from "react-helmet";
import { motion, AnimatePresence } from "framer-motion";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

import img2 from "../images/001279ed.jpg";
import img4 from "../images/M645426.jpg";
import img5 from "../images/M645491.jpg";

function HeroSection() {
  const images = [img2, img4, img5];

  const [currentImage, setCurrentImage] = useState(0);

  const goNext = () => {
    setCurrentImage((current) => (current + 1) % images.length);
  };

  const goPrevious = () => {
    setCurrentImage((current) => (current - 1 + images.length) % images.length);
  };

  const handleGalleryClick = (event) => {
    const { left, width } = event.currentTarget.getBoundingClientRect();
    const clickPosition = event.clientX - left;

    if (clickPosition < width / 2) {
      goPrevious();
    } else {
      goNext();
    }
  };

  return (
    <motion.div
      className="hero-container"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
    >
      <Helmet>
        <title>Octavio Garcia: home</title>
      </Helmet>

      <div className="herobody">
        <div className="hero-gallery" onClick={handleGalleryClick}>
          <img
            className="hero-gallery-sizer"
            src={img2}
            alt=""
            aria-hidden="true"
            onContextMenu={(e) => e.preventDefault()}
          />

          <AnimatePresence mode="sync">
            <motion.img
              key={currentImage}
              className="hero-gallery-image"
              src={images[currentImage]}
              alt="lost"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.6, ease: "easeInOut" }}
              onContextMenu={(e) => e.preventDefault()}
            />
          </AnimatePresence>
        </div>

        <div className="project-nav">
          <div className="line"></div>
        </div>
      </div>
    </motion.div>
  );
}

export default HeroSection;
